module.exports = __webpack_public_path__ + "static/media/SofiaProRegular.bd0a6d0d.otf";